import { getGeneralImage } from "../../../Helpers/functions";
import { WidgetItem } from "../widgets.types";

export default function WidgetCard({
  widgetItem,
  anyItemHasOldPrice,
  onAction,
  isLoading,
  isActionsDisabled,
  loadingKey,
}: {
  widgetItem: WidgetItem;
  anyItemHasOldPrice: boolean;
  onAction: (payload: any, widgetKey: string) => void;
  isLoading: boolean | null;
  isActionsDisabled: boolean;
  loadingKey: string;
}) {
  if (!widgetItem) return null;

  const {
    action,
    backgroundColor,
    borderColor,
    duration,
    hint,
    icon,
    name,
    oldPrice,
  } = widgetItem;

  const isButtonDisabled = isLoading || isActionsDisabled;
  const handleAction = () => {
    if (isButtonDisabled) return;
    onAction(action.payload, loadingKey);
  };

  const actionIconValue = action.icon
    ?.replace("{platform}", "ios")
    .replace("{size}", "3x");
  return (
    <div
      className="widget-card d-flex flex-column justify-content-start gap-1 pt-3 pb-2 rounded-3 position-relative"
      style={{
        background: backgroundColor,
        border: `1px solid ${borderColor}`,
        width: 106,
        height: anyItemHasOldPrice ? 180 : 165,
        marginTop: 32,
      }}
    >
      {/* Floating Icon */}
      {icon && (
        <div
          className="position-absolute start-50 translate-middle-x"
          style={{
            top: -19,
          }}
        >
          <img
            src={getGeneralImage(icon.iconPath)}
            alt=""
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background: "#fff",
              border: `1px solid ${icon.borderColor}`,
              zIndex: 90,
            }}
          />
        </div>
      )}

      {/* Name */}
      {name && (
        <div
          className="text-center small my-2 text-12"
          style={{ height: "30px" }}
        >
          {name.text}
        </div>
      )}

      {/* Duration */}
      {duration && (
        <div className="text-center fw-bold text-14" style={{ height: "24px" }}>
          {duration.text}
        </div>
      )}

      {/* Hint */}
      {hint && (
        <div
          className="text-center text-muted text-12"
          style={{ minHeight: "18px" }}
        >
          {hint.text}
        </div>
      )}

      {/* Old price */}
      {oldPrice ? (
        <div
          className="text-center small"
          style={{
            color: oldPrice.style?.textColor,
            textDecoration: oldPrice.style?.strikeThrough
              ? "line-through"
              : "none",
            minHeight: "18px",
          }}
          // style={{ minHeight: "18px" }}
        >
          {oldPrice.text}
        </div>
      ) : anyItemHasOldPrice ? (
        <div style={{ minHeight: "18px" }}></div>
      ) : null}

      {/* Action */}
      {action && (
        <div className="mt-auto d-flex justify-content-center">
          {action.text && (
            <button
              className="btn text-12 fw-bold d-flex gap-1 align-items-center w-content justify-content-center fw-bold"
              style={{
                background: action.color,
                color: action.textColor,
                borderRadius: 10,
                width: 80,
                height: 24,
                cursor: isButtonDisabled ? "not-allowed" : "pointer",
              }}
              onClick={handleAction}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  {action.icon && (
                    <img
                      src={actionIconValue}
                      alt="plus icon"
                      style={{ width: 14, height: 14 }}
                    />
                  )}
                  <span className="fw-bold text-12 mt-1">{action.text}</span>
                </>
              )}
            </button>
          )}

          {!action.text && action?.icon && (
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                background: action.color,
                color: action.textColor,
                width: 24,
                height: 24,
                cursor: isButtonDisabled ? "not-allowed" : "pointer",
              }}
              onClick={handleAction}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{
                    width: 14,
                    height: 14,
                    color: action.textColor,
                  }}
                />
              ) : (
                <img
                  src={actionIconValue}
                  alt="plus icon"
                  style={{
                    width: 24,
                    height: 24,
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
